angular.module('gym.privacy_policies', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.privacy_policies', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.privacy_policies.list', {
    url: '/privacy_policies',
    template: require('templates/gyms/privacy_policies/index.html.slim')
  }).state('gym.privacy_policies.new', {
    url: '/privacy_policies/new',
    template: require('templates/gyms/privacy_policies/edit.html.slim')
  }).state('gym.privacy_policies.edit', {
    url: '/privacy_policies/:policyId/edit',
    template: require('templates/gyms/privacy_policies/edit.html.slim')
  }).state('gym.privacy_policies.user_policy_responses', {
    url: '/user_policy_responses',
    controller: 'UserPolicyResponsesCtrl',
    template: require('templates/gyms/privacy_policies/user_policy_responses.html.slim')
  });
}]);
